import { NavLink, withRouter } from 'react-router-dom'
import React from 'react'
import { OperationModeIcon } from '../../root/components/common/operation-mode-icon'
import { TableVirtualized } from '../../root/components/common/table-virtualized/table'
import Icon from '@mdi/react'
import { mdiQrcodeScan } from '@mdi/js'
import {
    DeviceStatus,
    IsAssignedIcon,
    Tooltip
} from '../../root/components/common'
import { useSelector } from 'react-redux'
import { makeStyles, IconButton, Typography } from '@material-ui/core'
import BackspaceIcon from '@material-ui/icons/BackspaceOutlined'
import { Highlighted } from '../../root/components/common/highlighted'
import classNames from 'classnames'
import { UserPermissions } from 'web/src/services/permissions'
import { NetworkDeviceStatus } from '../../root/components/common/network-device-status'

const useStyles = makeStyles(theme => ({
    disabled: {
        '&&': {
            color: theme.quaternary
        }
    },
    disabledImage: {
        filter: 'opacity(0.2)'
    },
    nameLink: {
        ...theme.link
    },
    batteryWrapper: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center'
    },
    wifiWrapper: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end'
    },
    lastColumn: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end'
    },
    statusWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    qrIcon: {
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.3
        }
    },
    restoreIconButton: {
        color: theme.primary
    },
    deviceStatusShortText: {
        marginLeft: 4
    },
    assignmentRowBlocker: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: theme.background,
        opacity: 0.5
    }
}))

const NetworkDevicesTableComponent = ({
    embeded,
    onQrIconClick,
    devices,
    isLoading,
    isLoadingMore,
    onLoadMore,
    isDevicesToMoveMode,
    onRestoreDevice,
    sorting,
    onSort,
    search,
    history
}) => {
    const {
        theme,
        locale,
        user: { original_role }
    } = useSelector(state => state.main)

    const classes = useStyles()

    const Link = embeded
        ? prop => <NavLink target={'_blank'} {...prop} />
        : NavLink
    const isDisabledRow = isAssigned => {
        return !isAssigned && !UserPermissions.isAllOriginalGranted()
    }

    const handleLinkClick = e => {
        e.stopPropagation()
    }

    const columns = [
        {
            key: 'mode',
            label: '',
            sortable: false,
            dataType: 'string',
            width: 0.5,
            maxWidth: 30,
            alignCenter: true,
            render: ({ rowData, cellData }) => {
                const isAssigned = rowData.is_assigned
                return (
                    <OperationModeIcon
                        operationMode={rowData.operation_mode}
                        locale={locale}
                    />
                )
            }
        },
        // {
        //     key: 'name',
        //     label: locale.common.name,
        //     sortable: true,
        //     dataType: 'string',
        //     width: 1.5,
        //     render: ({ rowData, cellData }) => {
        //         const isAssigned = rowData.is_assigned
        //         return (
        //             <Typography noWrap variant="inherit">
        //                 <Link
        //                     onClick={handleLinkClick}
        //                     className={classNames(classes.nameLink)}
        //                     to={`/network-devices/${rowData.id}`}>
        //                     <Highlighted
        //                         text={rowData.name}
        //                         highlight={search}
        //                     />
        //                 </Link>
        //             </Typography>
        //         )
        //     }
        // },
        {
            key: 'serial_number',
            label: locale.locations.deviceSerial,
            sortable: true,
            dataType: 'string',
            width: 1,
            render: ({ rowData, cellData }) => (
                <Link
                    onClick={handleLinkClick}
                    className={classNames(classes.nameLink)}
                    to={`/network-devices/${rowData.id}`}
                >
                    <Highlighted
                        text={rowData.serial_number}
                        highlight={search}
                    />
                </Link>
            )
        },
        {
            key: 'description',
            label: locale.common.description,
            sortable: false,
            dataType: 'string',
            width: 1.5,
            render: ({ rowData, cellData }) => (
                <Typography noWrap variant="inherit">
                    {rowData.description ? (
                        <Tooltip
                            hover
                            placement="top"
                            text={rowData.description}
                        >
                            {rowData.description}
                        </Tooltip>
                    ) : (
                        '--'
                    )}
                </Typography>
            )
        },
        {
            key: 'location_name',
            label: locale.devices.location,
            sortable: true,
            dataType: 'string',
            width: 1.5,
            render: ({ rowData, cellData }) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {!rowData.is_assigned && (
                        <IsAssignedIcon
                            theme={theme}
                            locale={locale}
                            isLocked
                            isHidden={
                                !rowData.is_assigned &&
                                UserPermissions.isAllOriginalGranted()
                            }
                        />
                    )}
                    <Typography noWrap variant="inherit">
                        {isDisabledRow(rowData.is_assigned) ? (
                            <div>{rowData.location_name}</div>
                        ) : (
                            <Link
                                onClick={handleLinkClick}
                                className={classNames(classes.nameLink)}
                                to={`/locations/${rowData.location_id}/overview`}
                            >
                                {rowData.location_name}
                            </Link>
                        )}
                    </Typography>
                </div>
            )
        },
        {
            key: 'device_online_status',
            label: locale.devices.status,
            sortable: true,
            dataType: 'string',
            // alignCenter: true,
            width: 1.5,
            maxWidth: 150,
            render: ({ rowData }) => {
                let status = rowData.data?.tti?.status
                return <NetworkDeviceStatus value={status} />
            }
        },
        {
            key: 'qr_code',
            label: locale.devices.qrCode,
            sortable: false,
            dataType: 'string',
            alignCenter: true,
            width: 0.5,
            maxWidth: 70,
            render: ({ rowData, cellData }) => (
                <div>
                    <Icon
                        path={mdiQrcodeScan}
                        size={0.8}
                        color={theme.primary}
                        className={classes.qrIcon}
                        onClick={e => {
                            e.stopPropagation()
                            onQrIconClick(rowData['serial_number'])
                        }}
                    />
                </div>
            )
        },
        ...(isDevicesToMoveMode
            ? [
                  {
                      key: 'actions',
                      label: '',
                      sortable: false,
                      dataType: 'custom',
                      alignCenter: true,
                      width: 0.5,
                      render: ({ rowData, cellData }) => (
                          <IconButton
                              size="small"
                              className={classes.restoreIconButton}
                              onClick={e => {
                                  e.stopPropagation()
                                  onRestoreDevice(rowData.id)
                              }}
                          >
                              <BackspaceIcon />
                          </IconButton>
                      )
                  }
              ]
            : []),
        {
            key: 'assigment_row_blocker',
            label: '',
            sortable: false,
            dataType: 'custom',
            alignCenter: true,
            width: 0,
            render: ({ rowData, cellData }) => {
                if (isDisabledRow(rowData.is_assigned))
                    return <div className={classes.assignmentRowBlocker} />
                return null
            }
        }
    ]

    const navigateToDevice = rowObj => {
        history.push(`/network-devices/${rowObj.rowData.id}`)
    }

    return (
        <TableVirtualized
            data={devices}
            isLoadingMore={isLoadingMore}
            isLoading={isLoading}
            onLoadMore={onLoadMore}
            columns={columns}
            sorting={sorting}
            onSort={onSort}
            onRowClick={navigateToDevice}
        />
    )
}

const NetworkDevicesTable = withRouter(NetworkDevicesTableComponent)
export { NetworkDevicesTable }
